import { useEffect, useRef, useState } from 'react'

import Video from 'next-video'

import { gql } from '@apollo/client'
import PlaceholderVideo from 'Root/Component/Placeholder/Video/PlaceholderVideo'
import apolloClient from 'lib/apollo-client'
import { getTrackingProps } from 'lib/media-events-tracking'
import { useCurrentUserId } from 'lib/use-current-user-id'

const GET_ASPECT_RATIO = gql`
  query GetApectRatio($identifier: String!) {
    content(identifier: $identifier) {
      id
      ... on VideoContent {
        aspectRatio
      }
    }
  }
`

const Player = (props) => {
  const userId = useCurrentUserId()
  const [muxAssetReady, setMuxAssetReady] = useState(Boolean(props.aspectRatio))
  const videoRef = useRef<HTMLElement>(null)
  const placeholderRef = useRef<HTMLElement>(null)
  const placeholderNeedTransition = !muxAssetReady

  useEffect(() => {
    const refetchAspectRatio = async () => {
      await apolloClient.query({
        query: GET_ASPECT_RATIO,
        variables: {
          identifier: props.id,
        },
      })
    }

    if (!props.aspectRatio && muxAssetReady) {
      refetchAspectRatio()
    }
  }, [props.id, props.aspectRatio, muxAssetReady])

  const events = getTrackingProps(
    props.id,
    userId,
    props.setIsCompleted,
    props.onPlay,
    props.onVideoInteraction
  )

  const handleOnLoadedData = () => {
    if (videoRef.current.dataset.nextVideo === 'ready') {
      setMuxAssetReady(true)
    }
  }

  const handlePlaceholderVideoTransitioned = () => {
    placeholderRef.current.style.display = 'none'
    videoRef.current.style.maxHeight = '10000px'
  }

  return (
    <>
      {placeholderNeedTransition && (
        <span
          ref={placeholderRef}
          className={`flex justify-center transition-opacity ${
            muxAssetReady ? 'opacity-0' : 'block opacity-1'
          }`}
          onTransitionEnd={handlePlaceholderVideoTransitioned}
        >
          <PlaceholderVideo />
        </span>
      )}

      <Video
        src={props.url}
        ref={videoRef}
        poster={props.cover ?? undefined}
        onLoadedData={handleOnLoadedData}
        className="rounded-xl overflow-hidden transition-all duration-1000"
        accentColor="#9489fa"
        style={{
          aspectRatio: props.aspectRatio ? props.aspectRatio : '16/9',
          maxHeight: muxAssetReady ? '10000px' : 0,
        }}
        {...events}
      />
    </>
  )
}

export default Player
